import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TarifConfigurationService } from 'src/app/core/services/tarif-configuration.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-liste-tarif-configuration',
  templateUrl: './liste-tarif-configuration.component.html',
  styleUrls: ['./liste-tarif-configuration.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListeTarifConfigurationComponent implements OnInit {

  colonnesAffichees: string[] = ['actif', 'flgTarifParZone', 'montantForfait', 'poidsForfaitaireMax', 'montantParKgSup', 'actions'];
  sourceDonnees: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  indicateurChargement = true;
  totalEnregistrements: number = 0;

  constructor(
    public tarifConfigurationService: TarifConfigurationService,
    private router: Router,
    private toast: ToastService
  ) {
    this.sourceDonnees = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.chargerDonnees();
    this.tarifConfigurationService.obtenirListeTarifConfiguration(0, 500);
  }

  ngAfterViewInit() {
    this.sourceDonnees.paginator = this.paginator;
    this.sourceDonnees.sort = this.sort;
  }

  chargerDonnees() {
    this.tarifConfigurationService.donnees$.subscribe(
      donnees => {
        this.sourceDonnees.data = donnees;
        this.totalEnregistrements = donnees.length;
        this.indicateurChargement = false;
      },
      erreur => {
        console.error('Erreur lors de la récupération des données', erreur);
        this.indicateurChargement = false;
      }
    );
  }

  appliquerFiltre(event: Event) {
    const valeurFiltre = (event.target as HTMLInputElement).value;
    this.sourceDonnees.filter = valeurFiltre.trim().toLowerCase();
    if (this.sourceDonnees.paginator) {
      this.sourceDonnees.paginator.firstPage();
    }
  }

  ajouterTarif() {
    this.router.navigate(['/tarif/configuration/enregistrer']);
  }

  modifierTarif(id: number) {
    this.router.navigate(['/tarif/configuration/enregistrer', id]);
  }

  supprimerTarif(tarif: any) {
    this.toast.confirmer(
      `Êtes-vous sûr de vouloir supprimer cette configuration tarifaire ?`,
      'Confirmation de suppression'
    ).subscribe(confirme => {
      if (confirme) {
        this.tarifConfigurationService.supprimerTarifConfiguration(tarif.id).subscribe({
          next: () => {
            this.toast.succes('Configuration supprimée avec succès', 'Succès');
            const donneesMaj = this.sourceDonnees.data.filter(t => t.id !== tarif.id);
            this.sourceDonnees.data = donneesMaj;
            this.totalEnregistrements = donneesMaj.length;
            if (this.paginator) {
              this.paginator.length = this.totalEnregistrements;
              const pageIndex = this.paginator.pageIndex;
              const pageSize = this.paginator.pageSize;
              const nbPages = Math.ceil(this.totalEnregistrements / pageSize);
              if (pageIndex >= nbPages && pageIndex > 0) {
                this.paginator.previousPage();
              }
            }
            this.tarifConfigurationService.obtenirListeTarifConfiguration(0, 500);
          },
          error: (err) => {
            this.toast.erreur(err?.message || 'Erreur lors de la suppression', 'Erreur');
          }
        });
      }
    });
  }

  obtenirOuiNon(valeur: boolean): string {
    return valeur ? 'Oui' : 'Non';
  }

  obtenirClasseBadgeActif(actif: boolean): string {
    return actif ? 'badge-success' : 'badge-inactive';
  }
}
